import { useMutation, useQuery } from "@tanstack/react-query";
import { reportApi, ReportParams } from "@/api/report.api";

function isReady(params: ReportParams): boolean {
  if (params.type === "employee") return Boolean(params.employeeId);
  if (params.type === "customer") return Boolean(params.customerId);
  return true;
}

export function useReport(params: ReportParams) {
  return useQuery({
    queryKey: ["reports", params],
    queryFn: () => reportApi.getReport(params),
    enabled: isReady(params),
  });
}

export function useExportPdf() {
  return useMutation({ mutationFn: (params: ReportParams) => reportApi.exportPdf(params) });
}

export function useExportExcel() {
  return useMutation({ mutationFn: (params: ReportParams) => reportApi.exportExcel(params) });
}
